import React, { ReactNode, useState } from "react";
import { AlertTriangle, X } from "react-feather";
import { Label, LabelProps } from "semantic-ui-react";
import { Connotation } from "../../../types/types";

import "./ChipLabel.scss";

export interface ChipLabelProps extends LabelProps {
	label: string;
	rounded?: "rounded" | "square";
	closable?: boolean;
	onClose?: () => void;
	variant?: Connotation | "warning";
	icon?: ReactNode;
}

export default function ChipLabel({ label, rounded, closable, onClose, variant, icon, ...props }: ChipLabelProps) {
	const [isClosed, setClosed] = useState<boolean>(false);
	const onChipClose = () => {
		setClosed(true);
		onClose && onClose();
	};

	if (variant === "warning" && !icon) {
		icon = <AlertTriangle />;
	}

	return isClosed ? (
		<></>
	) : (
		<Label className={`${variant ? `chip-${variant}` : ""} ${rounded ?? ""}`} {...props}>
			<div className="chip-container" style={{ display: "flex" }}>
				{icon}
				<span>{label}</span>
				{closable && <X className="chip-close" onClick={onChipClose} color="black" size="1rem" />}
			</div>
		</Label>
	);
}
